import { Injectable } from '@angular/core';
import { ApiServiceBase } from '../../base/api-service-base';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../../authentication/auth.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PaymentMerchantReferenceModel } from '../../models/reference-model/reference-general-model/payment-merchant-reference.model';
import { PaymentMerchantSort, PaymentMerchantUpdateSortSequence } from '../../models/payment-acquirer-model';

@Injectable({
    providedIn: 'root'
})
export class PaymentMerchantReferenceService extends ApiServiceBase {
    private readonly PATH = '/system/PaymentMerchantReference';
    constructor(httpClient: HttpClient, authService: AuthService) {
        super(httpClient, authService);
    }

    public getAll(): Observable<PaymentMerchantReferenceModel[]> {
        return this.httpGet<PaymentMerchantReferenceModel[]>(this.PATH, null)
            .pipe(
                map(res => res.body)
            )
    }
    public getSort(paymentMerChantCode: string): Observable<PaymentMerchantSort[]> {
        return this.httpGet<PaymentMerchantSort[]>(this.PATH + "/sort/" + paymentMerChantCode, null)
            .pipe(
                map(res => res.body)
            )
    }
    public updateSortSequence(items: PaymentMerchantUpdateSortSequence[]): Observable<never> {
        return this.httpPut<never>(this.PATH + "/sort", items)
            .pipe(
                map(res => res.body)
            )
    }     
}
